<template>
  <el-dialog
    append-to-body
    width="600px"
    title="充值"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <!-- 支付方式 -->
    <div class="payType__wrap">
      <div
        v-for="item in payTypeList"
        :key="item.value"
        class="payType__item"
        :class="{ active: form.pay_type === item.value }"
        @click="selectPayType(item.value)"
      >
        <i :class="item.icon"></i>
        <span>{{ item.label }}</span>
        <i
          v-if="form.pay_type === item.value"
          class="el-icon-success check__icon"
        ></i>
      </div>
    </div>

    <!-- 微信收款信息 -->
    <div v-show="form.pay_type === 1" class="payInfo__wrap">
      <div class="payInfo__row">收款人：{{ weChat.name || "-" }}</div>
      <el-image
        style="width: 120px; height: 120px"
        v-if="weChat.code_url"
        :src="weChat.code_url"
        alt="微信收款二维码"
        :preview-src-list="[weChat.code_url]"
      />
      <div class="payInfo__tip">请使用微信扫码支付</div>
    </div>

    <!-- 银行卡收款信息 -->
    <div v-show="form.pay_type === 2" class="payInfo__wrap">
      <div class="payInfo__row">开户名称：{{ bank.bank_name || "-" }}</div>
      <div class="payInfo__row">开户银行：{{ bank.bank || "-" }}</div>
      <div class="payInfo__row">银行卡号：{{ bank.bank_no || "-" }}</div>
      <div class="payInfo__row" style="color: #f56c6c">
        打款备注: 支付兼职人员工资
      </div>
    </div>

    <!-- 打款信息 -->
    <el-form
      ref="formRef"
      class="rechargeForm"
      label-width="100px"
      :model="form"
      :rules="rules"
    >
      <el-form-item label="已完成打款" prop="ispay">
        <el-radio v-model="form.ispay" :label="true">是</el-radio>
      </el-form-item>
      <template v-if="form.ispay">
      <el-form-item label="充值金额" prop="amount">
        <el-input
          clearable
          v-model.trim="form.amount"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="打款人名称" prop="name">
        <el-input
          clearable
          v-model.trim="form.name"
          placeholder="请输入"
          maxlength="50"
        ></el-input>
      </el-form-item>
      <el-form-item label="用工单位" prop="company_name">
        <el-input
          clearable
          v-model.trim="form.company_name"
          placeholder="请输入"
          maxlength="50"
        ></el-input>
      </el-form-item>
      <el-form-item label="充值日期" prop="reg_time">
        <el-date-picker
          v-model="form.reg_time"
          type="date"
          placeholder="请选择"
          value-format="yyyy-MM-dd"
          style="width: 100%"
        ></el-date-picker>
      </el-form-item>
      </template>
    </el-form>

    <template slot="footer">
      <el-row type="flex" justify="center">
        <el-button
          class="theneBtn"
          type="primary"
          :loading="loading"
          :disabled="loading"
          @click="confirm"
          >确 定</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      loading: false,
      // 收款信息，父组件传入 { bank, weChat }
      payInfo: {},
      payTypeList: [
        { value: 1, label: "微信", icon: "el-icon-chat-dot-round" },
        { value: 2, label: "银行卡", icon: "el-icon-bank-card" },
      ],
      form: {
        pay_type: 0, // 1-微信 2-银行卡
        name: "", // 打款人名称
        company_name: "", // 用工单位
        reg_time: "", // 充值日期
        amount: "", // 充值金额
        ispay:'',
      },
      rules: {
        ispay: [{ required: true, message: "必填", trigger: "blur" }],
        amount: [{ required: true, message: "请输入", trigger: "blur" }],
        name: [
          { required: true, message: "请输入打款人名称", trigger: "blur" },
        ],
        company_name: [
          { required: true, message: "请输入用工单位", trigger: "blur" },
        ],
        reg_time: [
          { required: true, message: "请选择充值日期", trigger: "change" },
        ],
      },
    };
  },
  computed: {
    // 微信收款信息：{ name: 收款人, code_url: 二维码 }
    weChat() {
      return this.payInfo.weChat || {};
    },
    // 银行卡收款信息：{ bank_name: 开户名称, bank: 开户银行, bank_no: 银行卡号 }
    bank() {
      return this.payInfo.bank || {};
    },
  },
  methods: {
    // 获取收款信息
    getDetail(payInfo) {
      this.payInfo = payInfo || {};
    },
    // 切换支付方式
    selectPayType(value) {
      this.form.pay_type = value;
    },
    // 提交充值申请
    confirm() {
      if (!this.form.pay_type) {
        this.$message.warning("请选择支付方式！");
        return;
      }
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        let params = {
          pay_type: this.form.pay_type,
          name: this.form.name,
          company_name: this.form.company_name,
          reg_time: this.form.reg_time,
          amount: this.form.amount,
        };
        this.$http
          .post("/admin/flex_salary/add", params)
          .then((res) => {
            if (res.code === 1) {
              this.$message.success("操作成功");
              this.$emit("success");
              this.toggle(false);
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    reset(done) {
      this.payInfo = {};
      this.loading = false;
      this.form = {
        pay_type: 0,
        name: "",
        company_name: "",
        reg_time: "",
        amount: "",
        ispay:'',
      };
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate();
      });
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
  },
};
</script>

<style lang="scss" scoped>
.payType__wrap {
  display: flex;
  margin-bottom: 16px;

  .payType__item {
    position: relative;
    flex: 1;
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    color: #606266;
    cursor: pointer;
    transition: all 0.2s;

    & + .payType__item {
      margin-left: 12px;
    }

    i {
      margin-right: 6px;
      font-size: 18px;
    }

    .check__icon {
      margin: 0 0 0 6px;
      font-size: 16px;
    }

    &:hover {
      border-color: $theme;
      color: $theme;
    }

    &.active {
      border-color: $theme;
      color: $theme;
      background-color: #e6f1fd;
    }
  }
}

.payInfo__wrap {
  padding: 12px 16px;
  margin-bottom: 16px;
  background-color: #fafafa;
  border-radius: 4px;

  .payInfo__row {
    font-size: 14px;
    line-height: 28px;
    color: #606266;
    word-break: break-all;
  }

  .payInfo__tip {
    font-size: 13px;
    color: #909399;
  }
}

.qrcode__wrap {
  margin: 8px 0;

  img {
    width: 150px;
    height: 150px;
    display: block;
    border: 1px solid #ebeef5;
    background-color: #fff;
    object-fit: contain;
  }

  .qrcode__placeholder {
    width: 150px;
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #dcdfe6;
    background-color: #fff;
    color: #c0c4cc;
    font-size: 13px;
  }
}

.rechargeForm {
  margin-top: 4px;
}
</style>
